import { Button, Divider, Popover } from "antd";
import { useEffect, useState } from "react";
import { MdOutlineClose } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Chat.module.scss";
import call_green from "./images/call_green.svg";
import call_white from "./images/call_white.svg";
import chat_box from "./images/chat_box.svg";
import facebook from "./images/facebook.svg";
import instagram from "./images/instagram.svg";
import linkedin from "./images/linkedin.svg";
import twitter from "./images/twitter.svg";
import whatsapp_green from "./images/whatsapp_green.svg";
import whatsapp_white from "./images/whatsapp_white.svg";
import youtube from "./images/youtube.svg";

const Chat = () => {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();

    const [selectedOption, setSelectedOption] = useState("whatsapp");

    // when select whatsapp, on click the get started button, it will open the whatsapp chat
    const handleGetStarted = () => {
        switch (selectedOption) {
            case "whatsapp":
                window.open("https://api.whatsapp.com/send?phone=4917670009491&text=Hello!", "_blank");
                break;
            case "support":
                navigate("/support");
                break;
            case "call":
                window.open("tel:+4917670009491", "_blank");
                break;
            case "chat":
                setShow(false);
                window.$crisp.push(["do", "chat:open"]);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        window.$crisp = [];
        window.CRISP_WEBSITE_ID = "2226cb2c-22e9-4bdd-bbe8-06697d637dfd";

        (function () {
            var d = document;
            var s = d.createElement("script");

            s.src = "https://client.crisp.chat/l.js";
            s.async = 1;
            d.getElementsByTagName("head")[0].appendChild(s);
        })();
    }, []);

    const supportOptions = [
        {
            name: "Whatsapp",
            green_icon: whatsapp_green,
            white_icon: whatsapp_white,
            value: "whatsapp",
        },
        {
            name: "Call",
            green_icon: call_green,
            white_icon: call_white,
            value: "call",
        },
        // {
        //     name: "Chat",
        //     green_icon: chat_green,
        //     white_icon: chat_white,
        //     value: "chat",
        // },
    ];

    const socialMedia = [
        {
            name: "Twitter",
            icon: twitter,
            link: "https://twitter.com/DesiFresh_de",
        },
        {
            name: "Youtube",
            icon: youtube,
            link: "https://www.youtube.com/channel/UCPZDCA-MzmVJKRQ4FvCclCw",
        },
        {
            name: "Facebook",
            icon: facebook,
            link: "https://www.facebook.com/dfresh.de",
        },
        {
            name: "Instagram",
            icon: instagram,
            link: "https://www.instagram.com/dfresh_de",
        },
        {
            name: "Linkedin",
            icon: linkedin,
            link: "https://www.linkedin.com/company/desi-fresh",
        },
    ];

    // when popover open, lock the scroll
    useEffect(() => {
        if (show) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [show]);

    const chatPopoverContent = (
        <div className={styles.content}>
            <h2>How can we help you?</h2>
            <div className={styles.content_sub}>
                For quick and easy answers, check out our <Link to={"/faq"}>FAQ</Link> section.
            </div>
            <div className={styles.content_sub}>Or</div>
            <div className={styles.content_sub}>
                Save time by starting your <Link to={"/support"}>support request</Link> online
            </div>

            <div className={styles.content_sub} style={{ margin: "10px 0" }}>
                If you still need assistance, our support team is here to help you!
            </div>

            <div className="d-flex align-items-center gap-2 justify-content-center">
                {supportOptions.map((option, index) => (
                    <div
                        key={index}
                        className={selectedOption === option.value ? `${styles.option} ${styles.option_active}` : styles.option}
                    >
                        <div onClick={() => setSelectedOption(option.value)} className={styles.option_inner}>
                            <span>{option.name}</span>
                            <img src={selectedOption === option.value ? option.green_icon : option.white_icon} alt={option.name} />
                        </div>
                    </div>
                ))}
            </div>

            <div className={styles.get_started_btn}>
                <Button type="primary" onClick={handleGetStarted}>
                    Get Started
                </Button>
            </div>

            <Divider style={{ margin: "10px 0" }} />

            <div className={styles.content_sub}> Follow us on social media.</div>

            <div className={styles.social_media}>
                {socialMedia.map((media, index) => (
                    <div key={index}>
                        <a href={media.link} target="_blank" rel="noreferrer">
                            <img src={media.icon} alt={media.name} />
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <div
            className="position-relative"
            style={{
                display: window.location.pathname.includes(["products"]) ? "none" : "",
            }}
        >
            <div className={styles.chat__wrapper}>
                <Popover
                    content={chatPopoverContent}
                    title={
                        <div className={`${styles.chat_p_logo}`}>
                            <img height="75" src="/pre-book/order_modal_logo.svg" alt="logo" />
                            <div className={`position-absolute ${styles.close_icon}`} onClick={() => setShow(false)}>
                                <MdOutlineClose color="white" size={25} />
                            </div>
                        </div>
                    }
                    trigger="click"
                    open={show}
                    placement="topRight"
                    overlayClassName="custom_chat_popover"
                    onOpenChange={() => setShow(show ? false : true)}
                    showArrow={false}
                >
                    <div className={styles.chat}>
                        <img src={chat_box} alt="chat_box" />
                    </div>
                </Popover>
            </div>
        </div>
    );
};

export default Chat;
